<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useReveal } from '../composables/useReveal'

const { t } = useI18n()
const { elementRef: sectionRef, isVisible } = useReveal(0.15)
</script>

<template>
  <section id="contact" ref="sectionRef" class="section cta">
    <div class="container-narrow cta__inner">
      <h2 :class="['reveal', { visible: isVisible }]">{{ t('cta.title') }}</h2>
      <p :class="['reveal', 'reveal-delay-1', { visible: isVisible }]">{{ t('cta.subtitle') }}</p>
      <div :class="['cta__actions', 'reveal', 'reveal-delay-2', { visible: isVisible }]">
        <a href="mailto:sales@jmtms.com" class="btn btn-accent">{{ t('cta.primary') }}</a>
        <a href="tel:+8610xxxxxx" class="btn btn-secondary">{{ t('cta.secondary') }}</a>
      </div>
    </div>
  </section>
</template>

<style scoped>
.cta {
  background: var(--color-bg);
  text-align: center;
}

.cta__inner {
  padding: 5rem 3rem;
  border-radius: var(--radius-xl);
  background: var(--color-dark);
  color: var(--color-bg);
  position: relative;
  overflow: hidden;
}

.cta__inner::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 60% 80% at 0% 100%, rgba(13, 115, 119, 0.25), transparent 60%),
    radial-gradient(ellipse 50% 60% at 100% 0%, rgba(196, 92, 62, 0.15), transparent 50%);
  pointer-events: none;
}

.cta h2 {
  position: relative;
  z-index: 2;
  margin-bottom: 1.25rem;
  color: var(--color-bg);
}

.cta p {
  position: relative;
  z-index: 2;
  max-width: 560px;
  margin-inline: auto;
  margin-bottom: 2.5rem;
  color: var(--color-text-tertiary);
}

.cta__actions {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.cta__actions .btn-secondary {
  color: var(--color-bg);
  border-color: rgba(255, 255, 255, 0.25);
}

.cta__actions .btn-secondary:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.45);
}

@media (max-width: 640px) {
  .cta__inner {
    padding: 3rem 1.5rem;
  }

  .cta__actions {
    flex-direction: column;
  }

  .cta__actions .btn {
    width: 100%;
  }
}
</style>
